import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import LandingHero from '@/components/landing/LandingHero';
import LandingStats from '@/components/landing/LandingStats';
import LandingHowItWorks from '@/components/landing/LandingHowItWorks';
import LandingFeatures from '@/components/landing/LandingFeatures';
import LandingCompass from '@/components/landing/LandingCompass';
import LandingRutiniAI from '@/components/landing/LandingRutiniAI';
import LandingEcosystem from '@/components/landing/LandingEcosystem';
import LandingPricing from '@/components/landing/LandingPricing';
import LandingPrivacy from '@/components/landing/LandingPrivacy';
import LandingTestimonials from '@/components/landing/LandingTestimonials';
import LandingCTA from '@/components/landing/LandingCTA';
import LandingFooter from '@/components/landing/LandingFooter';
import LandingNav from '@/components/landing/LandingNav';
import StickyMobileCTA from '@/components/landing/StickyMobileCTA';
import LandingWaitlist from '@/components/landing/LandingWaitlist';
import InstallPrompt from '@/components/InstallPrompt';

const LandingPage = () => {
  const [pricingEnabled, setPricingEnabled] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await (supabase as any).rpc('get_public_pricing_enabled');
      if (typeof data === 'boolean') setPricingEnabled(data);
    };
    fetch();
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden pb-24 md:pb-0">
      <LandingNav />
      <LandingHero pricingEnabled={pricingEnabled} />
      <LandingStats />
      <LandingHowItWorks />
      <LandingTestimonials />
      <LandingFeatures />
      <LandingCompass />
      <LandingRutiniAI />
      <LandingEcosystem />
      {pricingEnabled && <LandingPricing />}
      <LandingPrivacy />
      <LandingWaitlist />
      <LandingCTA />
      <LandingFooter />
      <StickyMobileCTA />
      <InstallPrompt />
    </div>
  );
};

export default LandingPage;
